
export const areasVida = [
  { id: 'saude', label: 'Saúde e Vitalidade', icone: 'ri-heart-pulse-line', exemplo: 'Eu sou energia pura! Meu corpo é forte, saudável e vibrante a cada dia que passa!' },
  { id: 'financas', label: 'Finanças e Abundância', icone: 'ri-money-dollar-circle-line', exemplo: 'Eu sou abundância! O dinheiro flui para mim com facilidade e eu mereço toda prosperidade!' },
  { id: 'relacionamentos', label: 'Relacionamentos', icone: 'ri-heart-3-line', exemplo: 'Eu sou amor! Atraio relacionamentos incríveis e sou digno(a) de amor profundo!' },
  { id: 'carreira', label: 'Carreira e Propósito', icone: 'ri-briefcase-line', exemplo: 'Eu sou sucesso! Minha carreira cresce exponencialmente e eu impacto vidas todos os dias!' },
  { id: 'confianca', label: 'Confiança e Autoestima', icone: 'ri-shield-star-line', exemplo: 'Eu sou poder! Confio totalmente em mim e sou capaz de conquistar qualquer objetivo!' },
  { id: 'espiritualidade', label: 'Espiritualidade e Paz', icone: 'ri-mental-health-line', exemplo: 'Eu sou paz! Estou conectado(a) com minha essência e vivo em harmonia plena!' },
  { id: 'criatividade', label: 'Criatividade e Expressão', icone: 'ri-lightbulb-line', exemplo: 'Eu sou criatividade! Ideias brilhantes fluem através de mim e eu as manifesto com maestria!' },
  { id: 'disciplina', label: 'Disciplina e Foco', icone: 'ri-focus-3-line', exemplo: 'Eu sou foco absoluto! Minha disciplina é inabalável e eu conquisto tudo que decido!' }
];

export const regrasEncantation = [
  {
    numero: 1,
    titulo: 'Use o Presente',
    descricao: 'Sempre escreva como se já fosse verdade agora. Nunca use futuro.',
    exemplo: '\"Eu SOU forte\" em vez de \"Eu serei forte\"',
    icone: 'ri-time-line'
  },
  {
    numero: 2,
    titulo: 'Comece com \"Eu Sou\"',
    descricao: 'As palavras mais poderosas do universo. Elas definem sua identidade.',
    exemplo: '\"EU SOU abundância!\" — \"EU SOU confiança!\"',
    icone: 'ri-user-star-line'
  },
  {
    numero: 3,
    titulo: 'Use Emoção Intensa',
    descricao: 'Adicione palavras que geram emoção forte. Quanto mais intenso, melhor.',
    exemplo: '\"Eu sou INCRIVELMENTE poderoso(a)!\"',
    icone: 'ri-fire-line'
  },
  {
    numero: 4,
    titulo: 'Seja Específico',
    descricao: 'Quanto mais detalhada, mais poderosa. Descreva exatamente o que deseja.',
    exemplo: '\"Eu ganho R$ 20.000 por mês com facilidade!\"',
    icone: 'ri-crosshair-2-line'
  },
  {
    numero: 5,
    titulo: 'Adicione Movimento',
    descricao: 'Encantations exigem movimento físico. Caminhe, pule, gesticule com energia.',
    exemplo: 'Bata no peito, cerre os punhos, caminhe com poder',
    icone: 'ri-run-line'
  },
  {
    numero: 6,
    titulo: 'Repita com Intensidade',
    descricao: 'Fale em voz alta, com convicção total. Seu corpo precisa sentir cada palavra.',
    exemplo: 'Grite se necessário! A intensidade é a chave.',
    icone: 'ri-volume-up-line'
  }
];

export const momentosPratica = [
  { id: 'manha', label: 'Ao acordar (manhã)', icone: 'ri-sun-line' },
  { id: 'exercicio', label: 'Durante exercícios', icone: 'ri-run-line' },
  { id: 'banho', label: 'No banho', icone: 'ri-drop-line' },
  { id: 'carro', label: 'No carro/transporte', icone: 'ri-car-line' },
  { id: 'antes-dormir', label: 'Antes de dormir', icone: 'ri-moon-line' },
  { id: 'intervalo', label: 'Nos intervalos do trabalho', icone: 'ri-pause-circle-line' }
];

export const dicasTonyRobbins = [
  'A repetição é a mãe da habilidade. Pratique suas Encantations todos os dias por pelo menos 10 minutos.',
  'Seu estado emocional determina a qualidade da sua vida. Use Encantations para mudar seu estado instantaneamente.',
  'Não basta dizer as palavras — você precisa SENTIR cada sílaba no seu corpo inteiro.',
  'As pessoas de sucesso têm rituais matinais. Faça das Encantations parte do seu.',
  'Quando você muda sua fisiologia, muda sua psicologia. Movimento é essencial.'
];
